const DAILY_REPORT_STATUS = {
  PENDING: "Pending",
  COMPLETED: "Completed",
};

const DAILY_REPORT_QUESTION_CATEGORIES = {
  GENERAL: "General",
  IMPEDIMENT: "Impediment",
};

export { DAILY_REPORT_QUESTION_CATEGORIES };

export default DAILY_REPORT_STATUS;
